import React from 'react';
import PropTypes from 'prop-types';

/**
Wrapper that will auto-number any child NumberedBox components
*/
function AutoNumberedBoxes({
  children,
  id,
  start
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      '--st-numberbox-counter': id,
      counterReset: `var(--st-numberbox-counter) ${start - 1}`
    }
  }, children);
}
AutoNumberedBoxes.propTypes = {
  /** string to use as ID for counter */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** start counter at this number */
  start: PropTypes.number
};
AutoNumberedBoxes.defaultProps = {
  start: 1
};

export { AutoNumberedBoxes as A };
